import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/lovable-uploads/logo-2026.svg" 
        alt="AI World Congress 2026 - November 25-26, London Europe UK - AI Conference - AI Events 2026" 
        className="h-[59px] md:h-[64px] w-auto"
      />
    </div>
  );
};

export default Logo;
